<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { Container } from "@infinitro/container";
import { GradientText } from "@infinitro/text";
import VipBenefits from "./parts/alternative2/vip-benefits.svelte";
import VipEvents from "./parts/alternative2/vip-events.svelte";
import VipHero from "./parts/alternative2/vip-hero.svelte";
import VipRanksTable from "./parts/alternative2/vip-ranks-table.svelte";
import VipSteps from "./parts/alternative2/vip-steps.svelte";
import Faqs from "./parts/faqs.svelte";
</script>

<Container>
	<div class="about-vip-alternative2">
		<VipHero />
		<div class="about-vip-alternative2-content">
			<VipSteps />
			<VipBenefits />
			<VipEvents />
			<VipRanksTable />
			<Faqs />
		</div>
	</div>
</Container>

<style>
	.about-vip-alternative2 {

    position: relative;

    display: flex;

    height: 100%;

    width: 100%;

    flex-direction: column;

    gap: 6rem
}

	.about-vip-alternative2-content {

    margin-left: auto;

    margin-right: auto;

    display: flex;

    width: 100%;

    max-width: 1232px;

    flex-direction: column;

    gap: 6rem
}
</style>
